import React from 'react'
import './SecBTN.css'

const SecBTN = ({children,className,...rest}) => {
  return (
    <button className={`customButton ${className}`} {...rest}>
      {children}
    </button>
  );
}

export default SecBTN